import { useState } from 'react';

interface Props {
  label: string;
  onClick?: () => void;
  loading?: boolean;
  justCopied?: boolean;
}

export default function RefineBtn({ label, onClick, loading, justCopied }: Props) {
  const [hover, setHover] = useState(false);

  const highlighted = hover && !loading;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        padding: '6px 14px',
        borderRadius: 20,
        border: `1px solid ${highlighted ? '#666' : '#333'}`,
        background: 'transparent',
        color: highlighted ? 'var(--fg)' : '#b8b4af',
        fontFamily: 'inherit',
        fontSize: 12,
        fontWeight: 400,
        cursor: loading ? 'default' : 'pointer',
        whiteSpace: 'nowrap',
        transition: 'all 0.15s',
        opacity: loading ? 0.5 : 1,
      }}
    >
      {justCopied ? 'Copied!' : label}
    </button>
  );
}
